import { Col, Tooltip, Typography } from "antd";
import React, { useState } from "react";
import "./OrderAddress.css";
import EditAddressModal from "../../../../components/Modal/EditAddressModal/EditAddressModal";
import { ReactComponent as MobCreditWhiteIcon } from "../../../../assets/icons/mobCreditWhiteIcon.svg";
const { Text } = Typography;
const OrderAddress = (props) => {
  const [isMapLinkCopied, setIsMapLinkCopied] = useState(false);
  const {
    title,
    addressDetails,
    // func,
    addressType,
    addressID,
    deliveryAddress,
    orderId,
    order,
    editCheck,
    mobCredit = false,
    mob_credit_check,
  } = props;
  const name = addressDetails?.name;
  const address = addressDetails?.address_line_1;
  const address_line_2 = addressDetails?.address_line_2;
  const number = addressDetails?.phone_number;
  const gst = addressDetails?.gst_number;
  const city = addressDetails?.city;
  const pincode = addressDetails?.pincode;
  const state = addressDetails?.state;
  const googlemaplink = addressDetails?.google_map_link;
  const hasValidMapUrl =
    typeof googlemaplink === "string" &&
    /^(https?:\/\/)/i.test(googlemaplink.trim());
  const handleCopyMapLink = async () => {
    if (!hasValidMapUrl) return;
    try {
      await navigator.clipboard.writeText(googlemaplink);
      setIsMapLinkCopied(true);
      setTimeout(() => setIsMapLinkCopied(false), 1200);
    } catch (e) {
      setIsMapLinkCopied(false);
    }
  };
  return (
    <Col className="address-wrapper">
      <Col className="header">
        <Text className="title">{title}</Text>
        {/* <Text className="edit-btnn" onClick={func}>
          Edit
        </Text> */}
        {!editCheck && !mobCredit && (
          <EditAddressModal
            address={addressType}
            editState={""}
            addressID={addressID}
            deliveryAddress={deliveryAddress}
            orderId={orderId}
            order={order}
            mob_credit_check={mob_credit_check}
          />
        )}
      </Col>
      {addressDetails?.name ? (
        <Col className="body">
          <Text style={{ fontSize: "16px", display: "flex", gap: "5px" }}>
            {name}{" "}
            {addressType === "Billing" && mobCredit && (
              <>
                <MobCreditWhiteIcon />
              </>
            )}
          </Text>

          {addressType === "Billing" && gst && (
            <Text className="gst">{`GST NO: ${gst}`}</Text>
          )}
          {address && <Text style={{ fontSize: "16px" }}>{address},</Text>}
          {address_line_2 && (
            <Text style={{ fontSize: "16px" }}>{address_line_2},</Text>
          )}
          <Text style={{ fontSize: "16px" }}>
            {city}, {state}, {pincode}
          </Text>
          {hasValidMapUrl && (
            <div className="map-link-row">
              <a
                href={googlemaplink}
                target="_blank"
                rel="noreferrer"
                className="map-link"
              >
                View on Google Maps
              </a>
              <Tooltip
                title={isMapLinkCopied ? "Copied" : "Copy link"}
                open={isMapLinkCopied ? true : undefined}
                color="#fff"
                overlayInnerStyle={{ color: "#000" }}
              >
                <button
                  className="map-copy-btn"
                  type="button"
                  aria-label="Copy map link"
                  onClick={handleCopyMapLink}
                >
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="9" y="9" width="13" height="13" rx="2"></rect>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                  </svg>
                </button>
              </Tooltip>
            </div>
          )}
          <Text style={{ fontSize: "16px" }}>+91 {number}</Text>
          <Col span={24}>
            <Text className="card-project-text project-tag">
              {" "}
              Project:{" "}
              {addressDetails?.project ? (
                addressDetails?.project?.project_name
              ) : (
                <span className="text-danger-na">NA</span>
              )}
            </Text>
          </Col>
        </Col>
      ) : (
        <>
          <Text
            style={{
              fontSize: "16px",
              display: "block",
              padding: "12px 24px 16px 24px",
            }}
          >
            No address added
          </Text>
        </>
      )}
      {addressType === "Billing" && mobCredit && (
        <>
          <Col className="bottom-banner">
            Billing address can’t be edited as the payment is done through
            mobCREDIT
          </Col>
        </>
      )}
    </Col>
  );
};

export default OrderAddress;
